import * as _ from 'lodash-es';

type SortableSidebarItem = {
  id?: string | null;
  order?: number | null;
} & ({ name: string; title?: undefined } | { title: string; name?: undefined });

export default function sortSidebarItems<T extends SortableSidebarItem>(
  items: T[],
  orderIds: string[],
): T[] {
  const order = orderIds.reduce<{ [index: string]: number }>(
    (acc, id, index) => ({ ...acc, [id]: index }),
    {},
  );

  return _.sortBy(
    items.map((item) => ({
      ...item,
      order: item?.id ? (order[item.id] ?? null) : null,
    })),
    ['order', (item) => item.title ?? item.name],
  );
}
